import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "color"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Ribbon/Variant2.js";
import { withTheme } from '../../core/ThemeProvider';
import React from 'react';
import { BadgeIconContainer, Container, Content, Ribbon, TextVariant2 } from './styles';
var Variant2 = withTheme(function Variant2(_ref) {
  var children = _ref.children,
      Icon = _ref.icon,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, _excluded);

  var iconColor = color === 'secondary' ? rest.coreTheme.cl_sec_d2 : rest.coreTheme.cl_white;
  return /*#__PURE__*/React.createElement(Ribbon, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Container, {
    color: color,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, Icon && /*#__PURE__*/React.createElement(BadgeIconContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    color: iconColor,
    size: 24,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(TextVariant2, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 11
    }
  }, children))));
});
export default Variant2;